// add social links on pages at both hub and item level 

module.exports = function clickSocialMediaLinks() {
    let socialShareLinks = Array.from(document.querySelectorAll(`ul.share-hub > li > a`));
    const body = document.querySelector('body');

    //two uls with share-hub class and id on hub page (bummer) so had to slice the large node list in half
    if (body.classList.contains('hub-page')){
        socialShareLinks = socialShareLinks.slice(4);
    }

    const socialButtonLink = (event) => {
        event.preventDefault();
        socialShareLinks.forEach((link) => {
            if(link.dataset.share === event.currentTarget.classList[0]){
                link.click();
            }
        });
    };

    $(`li.social > a`).on('click', socialButtonLink);
    $(`li.socialContent > a`).on('click', socialButtonLink);
};


// WEBPACK FOOTER //
// ./scriptPartials/socialLinks.js